import { render, staticRenderFns } from "./PrivacyLjyd.vue?vue&type=template&id=7e45e76e&scoped=true"
import script from "./PrivacyLjyd.vue?vue&type=script&lang=js"
export * from "./PrivacyLjyd.vue?vue&type=script&lang=js"
import style0 from "./PrivacyLjyd.vue?vue&type=style&index=0&id=7e45e76e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e45e76e",
  null
  
)

export default component.exports